import React, { useEffect } from "react";
import WaitList from "Components/Waitlist";

export default function WaitlistPage() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top-left corner of the page
  }, []);
  return (
    <>
      <WaitList />
    </>
  );
}
